export default __webpack_public_path__ + "static/media/arrow.b6549a8e.svg";